import { SectionBlogCarousel } from '@sbercloud/uikit-product-site-section';
import { useRouter } from 'next/navigation';
import { useAnalytics } from 'src/hooks/useAnalytics';
import { useLayoutType } from 'src/hooks/useLayoutType';
import { EventCardType } from 'src/types/backendContent';
import { formatDate } from 'src/utils/formatDate';

export interface WebinarsCarouselProps {
  id?: string;
  title: string;
  slides: EventCardType[];
  className?: string;
}

export function WebinarsCarousel({ id, title, slides }: WebinarsCarouselProps) {
  const layoutType = useLayoutType();
  const { clickAnalytics } = useAnalytics();
  const router = useRouter();

  return (
    <SectionBlogCarousel
      title={title}
      titleTag="h2"
      id={id}
      data-test-id="warps-carousel"
      layoutType={layoutType}
      items={slides.map((slide) => {
        const href = `/events/${slide.slug}`;

        const badge =
          slide.status === 'ACTIVE'
            ? 'Регистрация открыта'
            : !slide.recordLink
            ? 'Запись скоро будет'
            : 'Доступна запись';

        return {
          img: slide.cover,
          date: formatDate(slide.startsAt),
          href,
          id: `webinar-card-link-${title}`,
          onClick: (e) => {
            e?.preventDefault();
            clickAnalytics({
              action: href,
              clickZone: 'body',
              clickElement: 'cardclick',
              clickContent: title,
              uniqueId: `webinar-card-link-${slide.title}`,
              transitionType: 'inside-link',
              clickZoneCategory: 'site-body',
              transitionUrl: href,
              transitionTypeMetrics: 'internal',
            });
            router.push(href);
          },
          'data-test-id': 'webinar-card',
          title: slide.title,
          tag: { label: badge },
          titleTag: 'span',
        };
      })}
    />
  );
}
